<template>
    <div>
        <div v-if="viewDPRMonth">
            <vs-row>
                <vs-col vs-xs="6" vs-sm="3" vs-lg="2">
                    <InputSelect
                        :model.sync="month"
                        placeholder="Select Month"
                        container_class="w-auto input-custom-dropdown my-3"
                        :multiple="false"
                        :options="month_options"
                    />
                </vs-col>
                <vs-col vs-xs="6" vs-sm="3" vs-lg="2">
                    <InputSelect
                        :model.sync="year"
                        placeholder="Select Year"
                        container_class="w-auto input-custom-dropdown my-3"
                        :multiple="false"
                        :options="year_options"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="4">
                    <InputSelect
                        :model.sync="package_"
                        placeholder="Select Package"
                        container_class="w-full my-3 mb-3"
                        :options="package_options"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="2" v-if="(createDPRMonth || editDPRMonth)">
                    <vs-button @click="showAddRowOptions()" class="my-3" color="primary">
                        <font-awesome-icon class="mr-2" :icon="addIcon"/>
                        Add Row
                    </vs-button>
                </vs-col>
            </vs-row>
    
            <template v-if="loading">
                <vx-card>
                    <h3>Loading Data.. Please wait..</h3>
                </vx-card>
            </template>
    
            <template v-else>
                <h3 v-if="report">{{ report.name }}</h3>
                <vs-row>
                    <vs-col>
                        <vs-table class="freeze_row row1" hoverFlat :data="package_keys" noDataText="No Parameters defined for this package" >
    
                            <template slot="thead">
                                <vs-th style="min-width: 70px;">Action</vs-th>
                                <vs-th style="min-width: 50px;">BOQ</vs-th>
                                <vs-th style="min-width: 190px;">Description of Work</vs-th>
                                <vs-th style="min-width: 80px;" class="text-center">Qty</vs-th>
                                <vs-th style="min-width: 100px;">Current Qty</vs-th>
                                <vs-th style="min-width: 80px;">UOM</vs-th>
                                <vs-th style="min-width: 80px;">Mandatory</vs-th>
                                <vs-th style="min-width: 80px;">Unit Rate</vs-th>
                                <vs-th style="min-width: 90px;">Weightage %</vs-th>
                                <vs-th style="min-width: 120px;">Freq.</vs-th>
                                <vs-th style="min-width: 140px;">Remarks</vs-th>
                                <vs-th style="min-width: 70px;">Status</vs-th>
                                <vs-th style="min-width: 140px;">Last Edited By</vs-th>
                                <vs-th style="min-width: 100px;">Closed Status</vs-th>
                                <vs-th style="min-width: 120px;">Closed On</vs-th>
                                <vs-th style="min-width: 120px;">Delete Action</vs-th>
                            </template>
    
                            <vs-tr v-for="(report_key, index) in package_keys" :key="index" :data="index" :disabled="report_key.is_heading">
                                <vs-td>
                                    <div class="flex items-center">
                                        <!-- <vs-checkbox v-model="selected_rows" name="selected_rows" :vs-value="report_key.id" v-if="!report_key.is_heading" :disabled="data[get_key(report_key.id)].status != 'p' || !(showReview) || !data[get_key(report_key.id)].id" /> -->
                                        <vx-tooltip v-if="!report_key.is_heading && hasPermission(data[get_key(report_key.id)]) && !report_mode" text="Edit BOQ & Description" color="primary">
                                            <vs-button @click="openEditPopup(report_key)" size="small" type="flat" class="ml-2">
                                                <font-awesome-icon class="text-primary" :icon="editIcon"/>
                                            </vs-button>
                                        </vx-tooltip>
                                    </div>
                                </vs-td>
                                <vs-td :class="{'font-bold': report_key.is_heading}">
                                    {{ report_key.boq_no.replace(report_key.parent_key ? `${report_key.parent_key.boq_no}.` : "", "") }}
                                </vs-td>
                                <vs-td :class="{'font-bold': report_key.is_heading}">
                                    {{ report_key.description }}
                                </vs-td>
                                <template v-if="report_key.is_heading">
                                    <vs-td colspan="13"></vs-td>
                                </template>
                                <template v-else>
                                    <vs-td>
                                        <vs-input size="small" v-model="data[get_key(report_key.id)].target_value" type="Number" min="0" step="0.3" class="w-full" :readonly="report_mode || !hasPermission(data[get_key(report_key.id)])" />
                                        <small class="block text-danger" v-if="api_errors.report_keys && api_errors.report_keys[report_key.id] && api_errors.report_keys[report_key.id].target_value">
                                            {{ api_errors.report_keys[report_key.id].target_value.join(',') }}
                                        </small>
                                    </vs-td>
                                    <vs-td>
                                        {{ (data[get_key(report_key.id)].current_value || 0).toFixed(3) }}
                                    </vs-td>
                                    <vs-td>
                                        <vs-input size="small" v-model="data[get_key(report_key.id)].params['unit_of_measurement']" class="w-full" :readonly="report_mode || !hasPermission(data[get_key(report_key.id)])" />
                                    </vs-td>
                                    <vs-td>
                                        <vs-checkbox size="small" v-model="data[get_key(report_key.id)].params['mandatory']" class="w-full" :disabled="report_mode || !hasPermission(data[get_key(report_key.id)])" />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input size="small" v-model="data[get_key(report_key.id)].params['unit_rate']" type="Number" min="0" step="0.5" class="w-full" :readonly="report_mode || !hasPermission(data[get_key(report_key.id)])" />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input size="small" v-model="data[get_key(report_key.id)].params['weightage']" type="Number" min="0" step="0.5" max="100" class="w-full" :readonly="report_mode || !hasPermission(data[get_key(report_key.id)])" />
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="report_mode">
                                            {{ data[get_key(report_key.id)].params['frequency'] || "0" }} times per <FormatText :text="data[get_key(report_key.id)].params['frequency_unit']" format="select" :kwargs="frequency_options" />
                                        </template>
                                        <template v-else>
                                            <vs-input size="small" v-model="data[get_key(report_key.id)].params['frequency']" type="Number" min="0" step="1" class="w-full" :readonly="report_mode || !hasPermission(data[get_key(report_key.id)])" placeholder="e.g. 1" />
                                            <small class="flex mt-1">
                                                <template v-for="(option, o_index) in frequency_options">
                                                    <vs-radio class="mx-1" size="small" :vs-name="`fq_opt_${index}`" :key="`opt_${index}_${o_index}`" :vs-value="option.value" :disabled="report_mode || !hasPermission(data[get_key(report_key.id)])" v-model="data[get_key(report_key.id)].params['frequency_unit']">{{  option.label }}</vs-radio>
                                                </template>
                                            </small>
                                        </template>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input size="small" v-model="data[get_key(report_key.id)].remarks" class="w-full" :readonly="report_mode || !hasPermission(data[get_key(report_key.id)])" />
                                        <small class="block text-danger" v-if="api_errors.report_keys && api_errors.report_keys[report_key.id] && api_errors.report_keys[report_key.id].remarks">
                                            {{ api_errors.report_keys[report_key.id].remarks.join(',') }}
                                        </small>
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="data[get_key(report_key.id)].status == 'p'">
                                            <template>
                                                <vx-tooltip text="Pending" color="warning">
                                                    <font-awesome-icon class="text-warning" :icon="pending" />
                                                </vx-tooltip>
                                            </template>
                                        </template>
                                        <template v-else-if="data[get_key(report_key.id)].status == 'a'">
                                            <template v-if="data[get_key(report_key.id)].reviewed_by">
                                                <vx-tooltip
                                                :text="`Approved By: ${data[get_key(report_key.id)].reviewed_by.first_name || ''} ${data[get_key(report_key.id)].reviewed_by.last_name || ''}`"
                                                color="success">
                                                    <font-awesome-icon class="text-success" :icon="approved" />
                                                </vx-tooltip>
                                            </template>
                                            <template v-else>
                                                <vx-tooltip text="Approved" color="success">
                                                    <font-awesome-icon class="text-success" :icon="approved" />
                                                </vx-tooltip>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-if="data[get_key(report_key.id)].reviewed_by">
                                                <vx-tooltip
                                                :text="`Rejected By: ${data[get_key(report_key.id)].reviewed_by.first_name || ''} ${data[get_key(report_key.id)].reviewed_by.last_name || ''}`"
                                                color="danger">
                                                    <font-awesome-icon class="text-danger" :icon="rejected" />
                                                </vx-tooltip>
                                            </template>
                                            <template v-else>
                                                <vx-tooltip text="Rejected" color="danger">
                                                    <font-awesome-icon class="text-danger" :icon="rejected" />
                                                </vx-tooltip>
                                            </template>
                                        </template>
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="data[get_key(report_key.id)].last_edited_by">
                                            {{ data[get_key(report_key.id)].last_edited_by.first_name || ''}} {{data[get_key(report_key.id)].last_edited_by.last_name || '' }}
                                        </template>
                                        <template v-else>
                                            {{ '' }}
                                        </template>
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="data[get_key(report_key.id)].closed_status == 'r'">
                                            <vx-tooltip text="Rejected" color="danger">
                                                <font-awesome-icon class="text-danger" :icon="rejected" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else-if="data[get_key(report_key.id)].closed_status == 'c'">
                                            <vx-tooltip text="Completed" color="success">
                                                <font-awesome-icon class="text-success" :icon="approved" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else>
                                            <vx-tooltip text="Pending" color="warning">
                                                <font-awesome-icon class="text-warning" :icon="pending" />
                                            </vx-tooltip>
                                        </template>
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="data[get_key(report_key.id)].closed_on">
                                            <FormatText :text="data[get_key(report_key.id)].closed_on" format="datetime" />
                                        </template>
                                        <template v-else>
                                            -
                                        </template>
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="delete_permission(data[report_key.id])">
                                            <vx-tooltip text= "Delete" color="danger">
                                                <vs-button @click="() => {
                                                    delete_popup.id = data[report_key.id].id
                                                    delete_popup.active = true
                                                }" size="small" type="flat">
                                                    <font-awesome-icon size="2x" class="text-danger" :icon="deleteIcon"/>
                                                </vs-button>
                                            </vx-tooltip>
                                        </template>
                                        <template v-else>
                                            -
                                        </template>
                                    </vs-td>
                                </template>
                            </vs-tr>
                        </vs-table>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-3" v-if="!report_mode">
                    <vs-col class="text-center">
                        <vs-button v-if="!selected_rows.length && (editDPRMonth || createDPRMonth)" @click="save_dpr" class="mx-auto">Save</vs-button>
                        <template v-if="selected_rows.length && showReview">
                            <vs-button @click="approve_all" class="mx-auto mr-3">Approve All</vs-button>
                            <vs-button @click="reject_all" class="mx-auto">Reject All</vs-button>
                        </template>
                    </vs-col>
                </vs-row>
            </template>
            <DeletePopup :is_active.sync="delete_popup.active" type="dpr monthly entry" @delete_issue="delete_issue" />
            
            <vs-popup :active.sync="addRowPopup.active" title="Add New Row" class="add-row-popup">
                <div>
                    <div class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-2">BOQ Number</label>
                        <vs-input v-model="addRowPopup.boqNo" placeholder="Enter BOQ Number" class="w-full" />
                    </div>
                    
                    <div class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-2">Description of Work</label>
                        <vs-textarea v-model="addRowPopup.description" placeholder="Enter Description of Work" class="w-full" rows="3" />
                    </div>
                    
                    <div class="text-center">
                        <vs-button @click="addRow" class="mx-2" color="primary" :disabled="!addRowPopup.boqNo || !addRowPopup.description">
                            Add Row
                        </vs-button>
                        <vs-button @click="closeAddRowPopup" class="mx-2" color="danger">
                            Cancel
                        </vs-button>
                    </div>
                </div>
            </vs-popup>

            <vs-popup :active.sync="editPopup.active" title="Edit BOQ & Description" class="edit-popup">
                <div>
                    <div class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-2">BOQ Number</label>
                        <vs-input v-model="editPopup.boqNo" placeholder="Enter BOQ Number" class="w-full" />
                    </div>
                    
                    <div class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-2">Description of Work</label>
                        <vs-textarea v-model="editPopup.description" placeholder="Enter Description of Work" class="w-full" rows="3" />
                    </div>
                    
                    <div class="text-center">
                        <vs-button @click="saveEdit" class="mx-2" color="primary" :disabled="!editPopup.boqNo || !editPopup.description">
                            Save Changes
                        </vs-button>
                        <vs-button @click="closeEditPopup" class="mx-2" color="danger">
                            Cancel
                        </vs-button>
                    </div>
                </div>
            </vs-popup>
        </div>
        <div v-else>
            <PermissionDenied />
        </div>
    </div>
</template>

<script>
import { faPlus, faClock, faCheckCircle, faTimesCircle, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../utils/requests'
import DeletePopup from '../components/DeletePopup.vue';

export default {
    components: {
        DeletePopup
    },
    props: {
        report_mode: {
            type: Boolean,
            required: false,
        }
    },
    data() {
        return {

            month: this.$route.query.month || new Date().getMonth() + 1,
            year: this.$route.query.year || new Date().getFullYear(),
            data: {},
            is_admin: this.$store.state.auth.userRole == 'admin',

            packages: [],

            // package
            package_: this.$route.query.package || null,
            package_keys: [],

            selected_rows: [],
            api_errors: {},

            loading_modules: {
                packages: false,
                package_keys: false,
                package_data: false
            },
            month_options: [
                {value: 1, label: "Jan"},
                {value: 2, label: "Feb"},
                {value: 3, label: "Mar"},
                {value: 4, label: "Apr"},
                {value: 5, label: "May"},
                {value: 6, label: "Jun"},
                {value: 7, label: "Jul"},
                {value: 8, label: "Aug"},
                {value: 9, label: "Sep"},
                {value: 10, label: "Oct"},
                {value: 11, label: "Nov"},
                {value: 12, label: "Dec"},
            ],

            delete_popup: {
                active: false,
                id: null
            },

            addRowPopup: {
                active: false,
                boqNo: '',
                description: ''
            },

            editPopup: {
                active: false,
                keyId: null,
                boqNo: '',
                description: ''
            },

            frequency_options: [
                {value: 'day', label: "Day"},
                {value: 'month', label: "Month"},
                {value: 'week', label: "Week"},
                {value: 'year', label: "Year"},
            ],

        }
    },
    computed: {
        addIcon: () => faPlus,
        pending: () => faClock,
        approved: () => faCheckCircle,
        rejected: () => faTimesCircle,
        deleteIcon: () => faTrash,
        editIcon: () => faEdit,
        year_options: () => {
            let years = []
            for (let i=new Date().getFullYear(); i>=1990; i--) {
                years.push({value: i, label: i.toString()})
            }

            return years
        },
        package_options() {
            return this.packages.map(v => {
                return {
                    value: v.id,
                    label: v.name
                }
            })
        },
        loading() {
            return Object.keys(this.loading_modules).filter(v => this.loading_modules[v] == true).length > 0
        },
        report() {
            let matches = this.$store.state.organisation.dpr_reports.filter(v => v.id == this.$route.params.report_id)
            if (matches.length) return matches[0]
            else return null
        },
        viewDPRMonth() { 
            return this.hasAccess('read', `dpr_log_month`, 'all')
        },
        createDPRMonth() { 
            return this.hasAccess('create', `dpr_log_month`, 'all')
        },
        editDPRMonth() { 
            return this.hasAccess('edit', `dpr_log_month`, 'all')
        },
        deleteDPRMonth() { 
            return this.hasAccess('delete', `dpr_log_month`, 'all')
        },
        showReview() { 
            return this.hasAccess('review', `dpr_log_month`, 'all') 
        },
    },
    watch: {
        month (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        year (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        package_ (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        '$route.params.report_id' (newV, oldV) {
            if (newV == oldV) return
            this.init()
        },
        "$route.query.package"(newV) {
            this.package_ = newV
        },
        "$route.query.month"(newV) {
            this.month = newV
        },
        "$route.query.year"(newV) {
            this.year = newV
        },
    },
    mounted() {
        this.init()
        if(Object.keys(this.$route.query).length) {
            this.load_data()
        }
    },
    methods: {
        init() {
            this.load_packages()
        },
        load_packages() {
            this.loading_modules.packages = true
            Request(this, 'GET', this.$store.state.apiendpoints.dpr_packages, {report: this.$route.params.report_id, limit: 100}).then(
                res => {
                    this.packages = res.results
                    this.loading_modules.packages = false
                    
                    if (this.packages.length && !(Object.keys(this.$route.query).length)) this.package_ = this.packages[0].id
                },
                err => {
                    this.loading_modules.packages = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while loading available packages! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    console.error(err)
                }
            )
        },
        load_data() {
            this.load_dpr_keys()
            this.load_dpr_data()
        },
        load_dpr_keys() {
            this.loading_modules.package_keys = true
            let url = `${this.$store.state.apiendpoints.dpr_package_keys}`

            let payload = {
                package: this.package_,
                limit: 100
            }

            Request(this, 'GET', url, payload).then(
                res => {
                    this.loading_modules.package_keys = false
                    this.package_keys = res.results
                },
                err => {
                    this.loading_modules.package_keys = false
                    this.package_keys = []
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while loading available report parameters! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_dpr_data() {
            this.loading_modules.package_data = true

            let url = `${this.$store.state.apiendpoints.dpr_month}`
            let payload = {
                month: this.month,
                year: this.year,
                package: this.package_
            }

            Request(this, 'GET', url, payload).then(
                res => {
                    this.loading_modules.package_data = false
                    // Assign data first
                    this.data = res || {}
                    // Ensure all nested params objects are reactive
                    if (this.data && typeof this.data === 'object') {
                        Object.keys(this.data).forEach(key => {
                            if (this.data[key] && !this.data[key].params) {
                                this.$set(this.data[key], 'params', {
                                    frequency: null,
                                    frequency_unit: null,
                                    weightage: null,
                                    unit_of_measurement: null,
                                    unit_rate: null,
                                    mandatory: null
                                })
                            } else if (this.data[key] && this.data[key].params) {
                                // Ensure params object is reactive by recreating it with $set
                                const params = this.data[key].params
                                this.$set(this.data[key], 'params', {
                                    frequency: params.frequency !== undefined ? params.frequency : null,
                                    frequency_unit: params.frequency_unit !== undefined ? params.frequency_unit : null,
                                    weightage: params.weightage !== undefined ? params.weightage : null,
                                    unit_of_measurement: params.unit_of_measurement !== undefined ? params.unit_of_measurement : null,
                                    unit_rate: params.unit_rate !== undefined ? params.unit_rate : null,
                                    mandatory: params.mandatory !== undefined ? params.mandatory : null
                                })
                            }
                        })
                    }
                },
                err => {
                    this.loading_modules.package_data = false
                    this.data = {}
                }
            )
        },
        save_dpr() {
            this.$vs.loading()

            let url = `${this.$store.state.apiendpoints.dpr_month}`

            let report_keys_data = {}
            Object.keys(this.data).forEach(key => {
                let package_key = this.package_keys.find(pk => pk.id == key)
                report_keys_data[key] = {
                    ...this.data[key],
                    boq_no: package_key ? package_key.boq_no : '',
                    description: package_key ? package_key.description : '',
                    report_key:package_key ? package_key.id : ''
                }
            })

            let payload = {
                month: this.month,
                year: this.year,
                package: this.package_,
                report_keys: report_keys_data
            }

            this.api_errors = {}

            Request(this, 'POST', url, null, payload).then(
                res => {
                    this.$vs.loading.close()
                    this.data = res
                    
                    if (res.package_keys) {
                        this.package_keys = res.package_keys
                    }

                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }

                }
            )
        },
        get_key(key) {
            if (!this.data[key]) {
                const defaultParams = this.package_keys.filter(obj => obj.id == key).length 
                    ? (this.package_keys.filter(obj => obj.id == key)[0].default_month_params || {})
                    : {
                        frequency: null,
                        frequency_unit: null,
                        weightage: null,
                        unit_of_measurement: null,
                        unit_rate: null,
                        mandatory: null
                    }
                
                this.$set(this.data, key, {
                    params: {
                        frequency: defaultParams.frequency || null,
                        frequency_unit: defaultParams.frequency_unit || null,
                        weightage: defaultParams.weightage || null,
                        unit_of_measurement: defaultParams.unit_of_measurement || null,
                        unit_rate: defaultParams.unit_rate || null,
                        mandatory: defaultParams.mandatory || null
                    },
                    remarks: null,
                    status: 'p',
                    target_value: 0,
                    current_value: 0
                })

            } else if(this.data[key] && !this.data[key]['params']) {
                const defaultParams = this.package_keys.filter(obj => obj.id == key).length 
                    ? (this.package_keys.filter(obj => obj.id == key)[0].default_month_params || {})
                    : {
                        frequency: null,
                        frequency_unit: null,
                        weightage: null,
                        unit_of_measurement: null,
                        unit_rate: null,
                        mandatory: null
                    }
                
                this.$set(this.data[key], 'params', {
                    frequency: defaultParams.frequency || null,
                    frequency_unit: defaultParams.frequency_unit || null,
                    weightage: defaultParams.weightage || null,
                    unit_of_measurement: defaultParams.unit_of_measurement || null,
                    unit_rate: defaultParams.unit_rate || null,
                    mandatory: defaultParams.mandatory || null
                })
            }
            // If params already exists, ensure it's reactive by ensuring the parent object is reactive
            // Don't recreate params if it exists to preserve values

            return key
        },
        approve(key) {
            let row = this.data[key]
            this.$set(this.data[key], 'disabled', true)
            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_month_action, row.id), null, {action: 'approve'}).then(
                res => {
                    this.$set(this.data[key], 'status', 'a')
                    this.$set(this.data[key], 'disabled', false)
                    this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                },
                err => {
                    this.$set(this.data[key], 'disabled', false)
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        reject(key) {
            let row = this.data[key]
            this.$set(this.data[key], 'disabled', true)
            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_month_action, row.id), null, {action: 'reject'}).then(
                res => {
                    this.$set(this.data[key], 'status', 'r')
                    this.$set(this.data[key], 'disabled', false)
                    this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                },
                err => {
                    this.$set(this.data[key], 'disabled', false)
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        approve_all() {
            this.selected_rows.forEach(key => this.approve(key))
        },
        reject_all() {
            this.selected_rows.forEach(key => this.reject(key))
        },
        delete_permission(item) {
            if(!item.id || !this.deleteDPRMonth) return false

            const issue_month = (new Date(item.created_on)).getMonth()
            const current_month = (new Date()).getMonth()

            if(issue_month==current_month) return true

            return false
        },
        delete_issue() {

            let url = this.$store.state.apiendpoints.dpr_month
            this.disabled = true

            let payload = {
                dpr_month_id: this.delete_popup.id
            }

            Request(this, 'DELETE', url, null, payload).then(
                (res) => {
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.load_dpr_data()
                    this.load_dpr_keys()
                    this.disabled = false
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: 'DPR monthly entry deleted successfully.',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        edit_permission(item) {

            if (!item.id || !this.editDPRMonth) return false

            if (item.status == 'a') return false

            return true
        },
        hasPermission(item) {
            if (!item) return false
            return (!item.id && this.createDPRMonth) || (item.id && this.edit_permission(item))
        },
        showAddRowOptions() {
            this.addRowPopup.boqNo = '';
            this.addRowPopup.description = '';
            this.addRowPopup.active = true;
        },
        closeAddRowPopup() {
            this.addRowPopup.active = false;
            this.addRowPopup.boqNo = '';
            this.addRowPopup.description = '';
        },
        addRow() {
            this.insertRowAtEnd();
            this.closeAddRowPopup();
        },
        insertRowAtEnd() {
            let parentKey = null;
            for (let i = this.package_keys.length - 1; i >= 0; i--) {
                if (this.package_keys[i].is_heading) {
                    parentKey = this.package_keys[i].id;
                    break;
                }
            }
            
            let keyIndex = 1;
            if (this.package_keys.length > 0) {
                const lastKeyIndex = this.package_keys[this.package_keys.length - 1].key_index || 0;
                keyIndex = lastKeyIndex + 1;
            }
            
            let url = `${this.$store.state.apiendpoints.dpr_report_key}`
            
            let payload = {
                month: this.month,
                year: this.year,
                package: this.package_,
                boq_no: this.addRowPopup.boqNo,
                description: this.addRowPopup.description,
                parent_key: parentKey,
                key_index: keyIndex
            }
            
            this.$vs.loading()
            
            Request(this, 'POST', url, null, payload).then(
                res => {
                    this.$vs.loading.close()
                    this.load_dpr_keys()
                    this.load_dpr_data()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Success',
                        text: 'New row added successfully!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: 'Failed to add new row. Please try again!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    console.error(err)
                }
            )
        },
        updateKeyIndexes() {
            this.package_keys.forEach(key => {
                key.key_index = 0;
            });
            
            let headingIndex = 1;
            this.package_keys.forEach(key => {
                if (key.is_heading) {
                    key.key_index = headingIndex++;
                }
            });
            
            this.package_keys.forEach(parent => {
                if (parent.is_heading) {
                    let childIndex = 1;
                    this.package_keys.forEach(child => {
                        if (!child.is_heading && child.parent_key && child.parent_key.id === parent.id) {
                            child.key_index = childIndex++;
                        }
                    });
                }
            });
            
            let orphanIndex = 1;
            this.package_keys.forEach(child => {
                if (!child.is_heading && (!child.parent_key || !child.parent_key.id)) {
                    child.key_index = orphanIndex++;
                }
            });
        },
        openEditPopup(reportKey) {
            this.editPopup.keyId = reportKey.id;
            this.editPopup.boqNo = reportKey.boq_no;
            this.editPopup.description = reportKey.description;
            this.editPopup.active = true;
        },
        closeEditPopup() {
            this.editPopup.active = false;
            this.editPopup.keyId = null;
            this.editPopup.boqNo = '';
            this.editPopup.description = '';
        },
        saveEdit() {
            if (!this.editPopup.keyId || !this.editPopup.boqNo || !this.editPopup.description) return;
            
            let keyIndex = this.package_keys.findIndex(key => key.id === this.editPopup.keyId);
            if (keyIndex !== -1) {
                this.package_keys[keyIndex].boq_no = this.editPopup.boqNo;
                this.package_keys[keyIndex].description = this.editPopup.description;
            }
            
            if (this.data[this.editPopup.keyId]) {
                this.$set(this.data[this.editPopup.keyId], 'boq_no', this.editPopup.boqNo);
                this.$set(this.data[this.editPopup.keyId], 'description', this.editPopup.description);
            }
            
            this.closeEditPopup();
            
            this.save_dpr();
        }
    }
}
</script>

